// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

export const MAX_PLAYERS = 8;
export const AUTO_SAVE_DEBOUNCE_MS = 800;
export const ACK_TIMEOUT_MS = 12000;

export const SIDEBAR_WIDTH_DEFAULT = 300;
export const SIDEBAR_WIDTH_WIDE = 340;
export const SIDEBAR_BREAKPOINT = 1200;
